exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*purgecss start ignore*/\n*[data-v-1027fada] {\n  will-change: height;\n  /*transform: translateZ(0);*/\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  /*perspective: 1000px;*/\n}\n\n/*purgecss end ignore*/\n", ""]);
